<template>
    <div class="xx-divider" />
</template>

<script>
export default {
    name: 'XxDivider'
};
</script>

<style lang="scss" scoped>
.xx-divider {
    box-sizing: border-box;
    background-color: #fafafb;
    height: 10px;
    border-top: 1px solid #eeeeee;
    border-bottom: 1px solid #eeeeee;
    // width: 120%;
    // margin-left: -20px;
}
</style>
